<div class="timeline-item "
     [ngClass]="'timeline-item-' + evtDetail.side">
    <div class="timeline-point"
         [ngClass]="'timeline-point-' + evtDetail.style">
        <i class="fas fa-fw"
           [ngClass]="'fa-' + evtDetail.icon + ' text-' + evtDetail.style"
           aria-hidden="true"></i>
    </div>
    <div class="timeline-event"
         [ngClass]="'timeline-event-' + evtDetail.style">
        <div class="timeline-content">
            <div class="timeline-header">
                <h4>{{evtDetail.title}}</h4>
            </div>
            <div class="timeline-body">{{tlItem.message}}</div>
            <div class="timeline-footer">
                <div class="timeline-author flex-overflow-ellipsis" title="{{tlItem.author}}">{{tlItem.author}}</div>
                <div class="timeline-date">{{tlItem.eventDateUtc | formatDateHour9}}</div>
            </div>
        </div>
    </div>
</div>
